﻿/* KANU HEART v4 - Space + Vault Alley */
(function() {
'use strict';


/* CANVAS ESPACE ETOILE PUR */
function initSpace() {
  var canvas = document.createElement('canvas');
  canvas.id = 'kanu-space-canvas';
  document.body.insertBefore(canvas, document.body.firstChild);
  var ctx = canvas.getContext('2d');
  var W, H, stars = [], shooters = [], frame = 0;

  function rnd(a,b){ return a+Math.random()*(b-a); }

  function build() {
    W = canvas.width = window.innerWidth;
    H = canvas.height = window.innerHeight;
    stars = [];
    // Trois couches d'etoiles blanches
    [[260,0.12,0.48,0.08,0.50],
     [100,0.48,1.00,0.50,0.88],
     [35, 1.00,2.00,0.78,1.00]].forEach(function(p){
      for(var i=0;i<p[0];i++){
        stars.push({
          x:rnd(0,W), y:rnd(0,H),
          r:rnd(p[1],p[2]),
          a:rnd(p[3],p[4]),
          spd:rnd(0.003,0.018),
          phi:rnd(0,Math.PI*2)
        });
      }
    });
  }

  function drawStars(t) {
    stars.forEach(function(s){
      var a = s.a * (0.55 + 0.45*Math.sin(t*s.spd + s.phi));
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(255,255,255,'+a+')';
      ctx.fill();
    });
  }

  function launchShooter() {
    var ang = rnd(15,45) * Math.PI/180; // angle diagonal vers le bas
    var spd = rnd(9,18);
    shooters.push({
      x: rnd(0, W),
      y: rnd(0, H*0.5),
      vx: Math.cos(ang)*spd,
      vy: Math.sin(ang)*spd,
      life: 1, trail: []
    });
  }

  function drawShooters() {
    shooters = shooters.filter(function(s){
      s.trail.push([s.x, s.y]);
      if(s.trail.length > 22) s.trail.shift();
      s.x += s.vx; s.y += s.vy; s.life -= 0.022;
      if(s.life <= 0 || s.x > W+50 || s.y > H+50) return false;
      if(s.trail.length < 2) return true;
      var g = ctx.createLinearGradient(s.trail[0][0],s.trail[0][1],s.x,s.y);
      g.addColorStop(0,'rgba(255,255,255,0)');
      g.addColorStop(0.6,'rgba(255,255,255,0.55)');
      g.addColorStop(1,'rgba(255,255,255,0.98)');
      ctx.beginPath();
      ctx.moveTo(s.trail[0][0], s.trail[0][1]);
      for(var i=1;i<s.trail.length;i++) ctx.lineTo(s.trail[i][0], s.trail[i][1]);
      ctx.lineTo(s.x, s.y);
      ctx.strokeStyle = g;
      ctx.lineWidth = 1.6;
      ctx.stroke();
      // Tete brillante
      ctx.beginPath();
      ctx.arc(s.x, s.y, 1.8, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(255,255,255,'+s.life+')';
      ctx.fill();
      return true;
    });
  }

  var t0=null;
  function loop(ts){
    if(!t0) t0=ts; var t=ts-t0; frame++;
    ctx.clearRect(0,0,W,H);
    // Fond espace noir profond avec tres legere teinte
    ctx.fillStyle='#03020a';
    ctx.fillRect(0,0,W,H);
    drawStars(t);
    // Etoiles filantes : toutes les ~5s en moyenne
    if(frame % 300 === 0 && Math.random() < 0.80) launchShooter();
    // Parfois 2 d'affilÃ©e
    if(frame % 300 === 12 && Math.random() < 0.35) launchShooter();
    drawShooters();
    requestAnimationFrame(loop);
  }
  build(); window.addEventListener('resize',build); requestAnimationFrame(loop);
}


/* REVEAL */
function initReveal() {
  var els = document.querySelectorAll('.card, .card__inner, h2, h3, .price, .badge');
  if (!els.length || !window.IntersectionObserver) return;
  els.forEach(function(el){ el.classList.add('kanu-reveal'); });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  },{threshold:0.12});
  els.forEach(function(el){ io.observe(el); });
}

// Fonctionne que le DOM soit deja pret ou non (corrige le bug defer)
function kanuInit() {
  initSpace(); initReveal();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', kanuInit);
} else {
  kanuInit();
}
})();
